// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopDelayReasons(projectId: string, startDate: string): Promise<Object> {
  // return axios.get(`${getBaseUrl()}projects/${projectId}/insights/top_delays?start_date=${startDate}`);
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/critical_activities?start_date=${startDate}`);
}
